<template>
  <div
    class="bg-FFFFFF width-full fb fb-cross-center fb-main-between"
    @click="handleClick(studentInfo)"
    :class="{ 'pl-16': showPaddingLeft }"
  >
    <div
      class="mr-12"
      v-show="showCheckbox"
      @click="studentInfo.selected = !studentInfo.selected"
      ><span
        class="iconfont font-48"
        :class="studentInfo.selected ? 'c-006AFE' : 'c-171A1D-24'"
        >{{ studentInfo.selected ? '&#xe66e;' : '&#xe66f;' }}</span
      ></div
    >
    <div
      class="w-36 h-36 bd-p-50 hidden c-FFFFFF font-28 fb fb-cross-center fb-main-center"
    >
      <img
        :src="
          require(`@/assets/images/avator${+studentInfo.gender || 0}-1.png`)
        "
      />
    </div>
    <div
      class="item-flex-1 ml-12 p-10-0 bg-FFFFFF fb fb-cross-center fb-main-between"
      :class="{ bb: showLine, 'pr-16': showPaddingRight }"
    >
      <div class="item-flex-1">
        <div class="fb fb-row fb-cross-center">
          <span
            class="inline-block font-34 lh-24 mr-4"
            :class="[
              !showAllClass && 'max-w-100 text-ellipsis ',
              tagWrap ? 'break-word' : ''
            ]"
            :style="{ 'max-width': maxWidth }"
            >{{ filterName(cpUserName, tagWrap ? 100 : nameLen) }}</span
          >
          <span
            class="iconfont font-32"
            :style="{
              color: +studentInfo.gender === 1 ? '#006AFE' : '#ff4d94'
            }"
            v-show="studentInfo.gender && !cpNotShowTags"
            v-html="SEX_TYPE_ICON[+studentInfo.gender]"
          ></span>
          <slot name="inline-tag"></slot>
        </div>
        <slot name="block-tag"></slot>
        <template v-if="cpNotShowTags">
          <div class="font-24 fb fb-main-start mt-4">
            <div class="fb fb-main-start fb-cross-center">
              <img
                class="icon-tip"
                src="@/assets/images/guardian/icon-classname.png"
              />
              <span class="inline-block">
                {{ filterName(cpClassName, 9) }}</span
              >
            </div>
            <div
              class="ml-16 fb fb-main-start fb-cross-center"
              v-if="studentInfo.adviserName"
            >
              <img
                class="icon-tip"
                src="@/assets/images/guardian/icon-headmaster.png"
              />
              <span class="inline-block max-w-100 text-ellipsis">{{
                filterName(studentInfo.adviserName, 5)
              }}</span>
            </div>
          </div>
          <div
            v-show="cpDorm"
            class="fb fb-main-start fb-cross-center font-24 mt-5"
          >
            <img class="icon-tip" src="@/assets/images/guardian/icon-bed.png" />
            <span class="inline-block"> {{ cpDorm }}</span>
          </div>
        </template>
        <template v-else>
          <div
            class="c-171A1D-56 font-28"
            :class="[showAllClass ? 'ellipsis-l2' : 'max-w-100 text-ellipsis ']"
            :style="{ 'max-width': maxWidth }"
            >{{ hideClass ? '' : filterName(cpClassName, 16) }}{{ cpDorm }}</div
          >
          <div
            v-show="(studentInfo.tagOptionList || []).length"
            class="fb fb-row fb-wrap fb-cross-center fb-main-starts"
          >
            <span
              v-for="item in studentInfo.tagOptionList"
              :key="item.tagOptionId"
              class="inline-block mt-4 h-22 lh-22 p-0-6 bg-006AFE-8 font-22 c-006AFE bd-radio-9999 mr-6 nowrap"
              >{{ item.tagOptionName }}</span
            >
          </div>
        </template>
        <slot></slot>
      </div>
      <div>
        <slot name="desc"></slot>
        <span v-show="showArrow" class="iconfont font-32 c-171A1D-40"
          >&#xe66b;</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import { SEX_TYPE_ICON } from '@/utils/constUtils'
import { filterName } from '@/utils/comUtils'
export default {
  name: 'studentHead',
  components: {},
  props: {
    tagWrap: {
      type: Boolean,
      default: true
    },
    isDept: {
      type: Boolean,
      default: false
    },
    showArrow: {
      type: Boolean,
      default: false
    },
    showAllClass: {
      type: Boolean,
      default: false
    },
    showPaddingLeft: {
      type: Boolean,
      default: false
    },
    showPaddingRight: {
      type: Boolean,
      default: true
    },
    showLine: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: String,
      default: '100px'
    },
    // 展示复选框
    showCheckbox: {
      type: Boolean,
      default: false
    },
    nameLen: {
      type: Number,
      default: 10
    },
    // 学生信息
    studentInfo: {
      type: Object,
      default: () => {
        return {
          id: '',
          name: '',
          gender: 0,
          className: '',
          dormName: '',
          tagOptionList: [],
          selected: false
        }
      }
    },
    // 是否隐藏班级
    hideClass: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      filterName,
      SEX_TYPE_ICON
    }
  },
  computed: {
    cpCurIsGuardianRole() {
      return ((this.$store || {}).getters || {}).curIsGuardian || false
    },
    cpCurIsStudent() {
      let { token } = (this.$store || {}).getters || {}
      return !!(token && token.schoolInfo && token.schoolInfo.isStudent)
    },
    cpNotShowTags() {
      return this.cpCurIsStudent || this.cpCurIsGuardianRole
    },
    cpAvator() {
      return Math.ceil(Math.random() * 3)
    },
    cpUserName() {
      const { userName, name, studentName, studentDingName, personName } =
        this.studentInfo || {}
      return (
        userName || name || studentName || studentDingName || personName || ''
      )
    },
    cpDorm() {
      return this.studentInfo.dormName
        ? `${
            this.hideClass || !this.cpClassName || this.cpNotShowTags ? '' : '/'
          }${this.studentInfo.dormName}` // todo  床
        : ''
    },
    cpClassName() {
      const {
        className,
        classDingName,
        dingDeptName,
        deptName,
        classNickName
      } = this.studentInfo || {}
      return (
        className ||
        classDingName ||
        dingDeptName ||
        deptName ||
        classNickName ||
        ''
      )
    }
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    handleClick(studentInfo) {
      this.$emit('click', studentInfo)
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-tip {
  margin-right: 5px;
  width: 18px;
  height: 18px;
}
.break-word {
  word-break: break-all;
}
</style>
